import { SerializedError } from "@reduxjs/toolkit";
import { ErrorData } from "type";
// import { ErrorData } from "type.d.ts";

export enum DataState {
  INITIAL,
  LOADING,
  ERROR,
  FULFILLED,
}

export const asErrorData = (error?: Error | SerializedError): ErrorData => {
  if (!error) {
    return { message: "An unknown error occurred." };
  // } else if (error instanceof ApiError) {
  //   return {
  //     code: error.code,
  //     message: error.message,
  //     type: error.type,
  //     data: error.data,
  //   };
  }

  return { message: error.message, type: error.name };
};
